import { v3SingleHttpsStatusCodeWithMessage } from "./v3.apiErrors";

export const v3HttpsStatusCodesWithMessages: v3SingleHttpsStatusCodeWithMessage[] =
  [
    { rw: "OK", en: "OK", status: 200 },
    { rw: "Byakozwe", en: "Created", status: 201 },
    { rw: "Byemewe", en: "Accepted", status: 202 },
    { rw: "Ntacyo mwohereje", en: "No Content", status: 204 },
    { rw: "Ibyo mwohereje ntago byuzuye", en: "Partial Content", status: 206 },
    { rw: "Byimuwe burundu", en: "Moved Permanently", status: 301 },
    { rw: "Byabonetse", en: "Found", status: 302 },
    { rw: "Reba ibindi", en: "See Other", status: 303 },
    { rw: "Ntago byahinduwe", en: "Not Modified", status: 304 },
    { rw: "Kwimurwa by'agateganyo", en: "Temporary Redirect", status: 307 },
    { rw: "Kwimurwa bya burundu", en: "Permanent Redirect", status: 308 },
    { rw: "Ibyo mwohereje ntabwo ari byo", en: "Bad Request", status: 400 },
    { rw: "Ntaburenganzira", en: "Unauthorized", status: 401 },
    { rw: "Kwishyura birakenewe", en: "Payment Required", status: 402 },
    { rw: "Mubujijwe gukora iki gikorwa", en: "Forbidden", status: 403 },
    { rw: "Ibyo mwasabye ntabihari", en: "Not Found", status: 404 },
    {
      rw: "Ubusabe mwakoze ntago bwemewe",
      en: "Method Not Allowed",
      status: 405
    },
    { rw: "Ntibyemewe", en: "Not Acceptable", status: 406 },
    { rw: "Amakimbirane", en: "Conflict", status: 409 },
    { rw: "Byaragiye", en: "Gone", status: 410 },
    {
      rw: "Mediya mwohereje ntago yemewe",
      en: "Unsupported Media Type",
      status: 415
    },
    { rw: "Ntibikunze gutunganywa", en: "Unprocessable Entity", status: 422 },
    { rw: "Mwakoze ubusabe bwinshi", en: "Too Many Requests", status: 429 },
    {
      rw: "Habaye ikibaz0. Hamagara ababishinzwe",
      en: "Internal Server Error",
      status: 500
    },
    { rw: "Ntago byakozwe", en: "Not Implemented", status: 501 },
    { rw: "Mwinjiriye ahatariho", en: "Bad Gateway", status: 502 },
    { rw: "Serivisi ntago iboneka", en: "Service Unavailable", status: 503 },
    { rw: "Aho mwinjiriye hararangiye", en: "Gateway Timeout", status: 504 },
    {
      rw: "HTTP yanyu ntago yemewe",
      en: "HTTP Version Not Supported",
      status: 505
    }
  ];

export const v3StatusCodes = [
  200, 201, 202, 204, 206, 301, 302, 303, 304, 307, 308, 400, 401, 402, 403,
  404, 405, 406, 409, 410, 415, 422, 429, 500, 501, 502, 503, 504, 505
] as const;

export const v3TranslatedDefaultErrorMessage = {
  rw: "Hari ibyagenze nabi, hamagara abatekinisiye!",
  en: "Something went wrong, please notify your tech support!"
};
